/**
 * GET /users/me/permissions — the caller's own effective permissions, computed
 * server-side from the Casbin policy that enforcement reads. Any authenticated
 * user may call it; it never describes anyone but the caller.
 * Field names match backend permissions.Grant json tags.
 */
import { apiClient } from './index';

export interface Grant {
  resource: string;
  action: string;
}

export const fetchMyPermissions = (): Promise<Grant[]> =>
  apiClient.get<{ data: Grant[] }>('/users/me/permissions').then((r) => r.data.data ?? []);
